// extracted by mini-css-extract-plugin
export var container = "_7y-0";
export var containerTopRight = "_7y-1";